/**
 * Shared drag-and-drop payload types for todos calendar views.
 * Use JSON.stringify for dataTransfer.setData and JSON.parse when reading.
 */
export type DraggedTodo = { type: 'todo'; id: number };
export type DraggedAppointment = { type: 'appointment'; id: number };
export type DraggedItem = DraggedTodo | DraggedAppointment;

export const DRAG_TYPE = 'application/x-ums-todos-calendar';

export function setDragData(e: React.DragEvent, payload: DraggedItem): void {
  e.dataTransfer.effectAllowed = 'copyMove';
  e.dataTransfer.setData(DRAG_TYPE, JSON.stringify(payload));
  e.dataTransfer.setData('text/plain', JSON.stringify(payload)); // fallback for some browsers
}

export function getDragData(e: React.DragEvent): DraggedItem | null {
  const raw = e.dataTransfer.getData(DRAG_TYPE) || e.dataTransfer.getData('text/plain');
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as DraggedItem;
    if (parsed?.type === 'todo' && typeof parsed.id === 'number') return parsed;
    if (parsed?.type === 'appointment' && typeof parsed.id === 'number') return parsed;
  } catch {
    // ignore
  }
  return null;
}
